import httpHelper from "@/helpers/httpHelper";
// action types
export const REGISTER_WITH_ENAMAD = "registerWithEnamd"; 

//mutation types
// export const SET_INQUIRY_ENAMAD = "getInquiryEnamad";

export default {
    state: {
        
        // resultInquiry:null,
        
    },
    getters: {
        /**
         * loade list of Gateway
         * @param state
         * @returns {*}
         */
        // loadedResultInquiry(state) {
        //     return state.resultInquiry;
        // },
    },
    actions: {
       
        
        /**
         * Set the create listCheckout
         * @param state
         * @param payload
         */
         [REGISTER_WITH_ENAMAD](context,payload) {
            
            return new Promise((resolve, reject) => {
            httpHelper
                .postData('enamad/register-user',payload)
                .then((response) => {
                    // context.commit(SET_INQUIRY_ENAMAD,response.result)
                    resolve(response)
                }).catch((error) => {
                    reject(error)
                })
            });
        },
    },
    mutations: {
       
        // [SET_INQUIRY_ENAMAD](state, payload) {
        //     state.resultInquiry = payload
        //     console.log("resultInquiry:",state.resultInquiry);
        // }
    }
};